import { CheckBox } from "@mui/icons-material";
import { Box, IconButton, keyframes, Typography } from "@mui/material";
import { React } from "react";
import "tippy.js/dist/tippy.css";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import UploadCloudIco from "../../../../assets/icons/UploadCloudIco";
import CommonLinearProgress from "../../../../component/Linearprogress";
import { GetFileIcon } from "../../../../utils/constants";
import { CommonTippy, CustomizeSpan } from "../../../jobs/style";
import {
  FileContainer,
  FileSpan,
  StyledLinearContainer,
  StyledSpaceBetweenBox,
  UploadDiv,
} from "./StyledComponent";
import { CustomDiv } from "../../../chat-bot/style";

const FileUpload = ({
  onDragOver,
  onDragLeave,
  onDrop,
  isDragging,
  onChange,
  files,
  handleDeleteFile,
  disabled = true,
  isJem,
  marginBottom,
  border,
  fileText,
}) => {
  console.log(files, "addMoreCandidateFiles");
  return (
    <>
      <Box
        onDragOver={disabled ? () => {} : onDragOver}
        onDragLeave={disabled ? () => {} : onDragLeave}
        onDrop={disabled ? () => {} : onDrop}
        border={border || "1px solid #EAECF0"}
        borderRadius={"12px"}
        padding={"20px"}
        textAlign={"center"}
        marginBottom={marginBottom || 3}
        backgroundColor={isDragging ? "#F0EAFD" : "#F9F9F9"}
        transition={"background-color 0.3s"}
      >
        <input
          type="file"
          multiple={isJem ? false : true}
          onChange={(event) => {
            onChange(event);
            event.target.value = "";
          }}
          disabled={disabled}
          style={{ display: "none" }}
          id="file-input"
        />
        <label
          htmlFor="file-input"
          style={{
            cursor: disabled ? "auto" : "pointer",
            opacity: disabled ? "0.5" : 2,
          }}
        >
          <UploadDiv>
            <UploadCloudIco />
          </UploadDiv>
          <Typography fontSize={"14px"} marginTop={1}>
            <FileSpan color="#6941C6" fontWeight={600}>
              Click to upload{" "}
            </FileSpan>
            <FileSpan color="#475467" fontWeight={400}>
              or drag and drop
            </FileSpan>
          </Typography>
          {/* <Typography
            sx={{ color: "#475467", fontWeight: 400, fontSize: "12px" }}
          >
            {fileText || "PDF, DOCX, or DOC"}
          </Typography> */}
        </label>
      </Box>

      {files?.map((file, index) => (
        <FileContainer key={index} elevation={1} gap={"1rem"}>
          <Box display={"flex"} alignItems={"flex-start"} className={"kathir"}>
            <GetFileIcon file={file} />
          </Box>

          <Box width={"100%"}>
            <StyledSpaceBetweenBox>
              <Typography
                color="#344054"
                fontSize={"14px"}
                fontWeight={700}
                style={{ wordBreak: "break-word" }}
              >
                {file.name}
              </Typography>

              <IconButton
                onClick={() => (file.delete ? handleDeleteFile(index) : "")}
                sx={{
                  padding: "0px",
                  cursor: file.delete ? "pointer" : "auto",
                }}
              >
                {file.progress === 100 && !file.delete && (
                  <CheckBox sx={{ color: "#7F56D9" }} />
                )}
                {file.delete && <DeleteIco />}
              </IconButton>
            </StyledSpaceBetweenBox>
            <Typography color="#475467" fontSize={"14px"} fontWeight={500}>
              {file.size}
            </Typography>
            {(file.progress >= 0 || file.visible) && (
              <CommonTippy
                content={file.message}
                visible={file.visible}
                interactive={true}
                trigger="click"
                hideOnClick={false}
                zIndex={2}
                color="red"
              >
                <CustomDiv>
                  <StyledLinearContainer>
                    <CommonLinearProgress
                      variant={
                        file.progress && !file.visible
                          ? "buffer"
                          : "determinate"
                      }
                      value={file.progress}
                      valueBuffer={file.buffer}
                      height={"8px"}
                      borderRadius={"2px"}
                      backgroundColor={"#E0E0E0"}
                      barbackgroundColor={file.visible ? "red" : "#7F56D9"}
                      dashedmarginTop={"2px"}
                      dashedbackgroundImage={
                        file.visible
                          ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                          : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                      }
                    />

                    <Typography
                      color="#344054"
                      fontSize={"14px"}
                      fontWeight={500}
                    >
                      {file.progress}%
                    </Typography>
                  </StyledLinearContainer>
                  {file.progress_message && (
                    <CustomizeSpan
                      fontSize="12px"
                      color="#475467"
                      sx={{
                        letterSpacing: "0.2px",
                        animation: "wave 1.5s ease-in-out infinite",
                        "@keyframes wave": {
                          "0%, 100%": { transform: "translateY(0)" },
                          "50%": { transform: "translateY(-4px)" },
                        },
                      }}
                    >
                      {file.progress_message} . . .
                    </CustomizeSpan>
                  )}
                </CustomDiv>
              </CommonTippy>
            )}
          </Box>
        </FileContainer>
      ))}
    </>
  );
};
export default FileUpload;
